import { CreateMovimentacaoDto } from "../shared/dtos/Movimentacao.dto";
import api from "./api";

interface Movimentacao {
  id: number;
  data_movimentacao: string;
  tipo: string;
  data_fim_carencia: string;
  observacao: string;
  // Adicione outros campos conforme a estrutura da sua movimentação
}

interface ResponseCreateMovimentacao {
  status: boolean;
  message: string;
  movimentacao: Movimentacao;
}

// Classe para lidar com as operações de movimentação
class MovimentacaoService {
  async createMovimentacao(
    data: CreateMovimentacaoDto
  ): Promise<ResponseCreateMovimentacao> {
    return api
      .post<ResponseCreateMovimentacao>("/movimentacao/create", data) // Aqui definimos o tipo da resposta esperada
      .then((response) => {
        // Verificar se a resposta é bem-sucedida (de acordo com a estrutura que o backend retorna)
        if (response.data.status === true) {
          // Retorne o que for necessário para o front-end, como os dados da movimentação
          return Promise.resolve(response.data);
        } else {
          // Caso a resposta tenha status false ou não seja o esperado
          console.error(
            "Erro na criação da movimentação:",
            response.data.message
          );
          return Promise.reject(response.data.message || "Erro desconhecido");
        }
      })
      .catch((error) => {
        // Tratamento do erro que pode vir do backend ou de outros problemas de rede
        if (error.response) {
          // Erro retornado pelo servidor
          console.error("Erro ao criar movimentação:", error.response.data);
          return Promise.reject(error.response.data);
        } else {
          // Erro de rede ou outro problema
          console.error("Erro de rede ou outro problema:", error.message);
          return Promise.reject(error.message);
        }
      });
  }

  async getMovimentacoesByContribuinte(idContribuinte: number) {
    return api
      .get(`/movimentacao/${idContribuinte}/movimentacoes`)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error(
          "Erro ao obter movimentações:",
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error);
      });
  }

  async updateMovimentacao(id: number, data: CreateMovimentacaoDto) {
    return api
      .patch(`/movimentacao/update/${id}`, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error(
          "Erro ao atualizar movimentação:",
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error);
      });
  }
  async deleteMovimentacao(id: number) {
    return api
      .delete(`/movimentacao/delete/${id}`)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error(
          "Erro ao remover movimentação:",
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error);
      });
  }
}

const movimentacaoService = new MovimentacaoService();
export default movimentacaoService;
